import createLucideIcon from '../createLucideIcon';

const ArrowUp = createLucideIcon('ArrowUp', [
  ['line', { x1: '12', x2: '12', y1: '19', y2: '5', key: 'jt6ph2' }],
  ['polyline', { points: '5 12 12 5 19 12', key: '1y7d7k' }],
]);

export default ArrowUp;
